import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { BookingReason } from "@app/models/rest/booking-reason";

@Injectable({
  providedIn: "root"
})
export class BookingReasonRestService extends HateoasResourceOperation<BookingReason> {
  constructor() {
    super(BookingReason);
  }
}
